"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _toggleButton = _interopRequireDefault(require("../toggleButton/toggleButton.presenter"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ToggleButtonGroup = function ToggleButtonGroup(_ref) {
  var buttons = _ref.buttons,
    toggleAllDisabled = _ref.areAllDisabled,
    onToggleAll = _ref.onToggleAll,
    toggleAllTooltip = _ref.tooltip,
    toggleAllLabel = _ref.label,
    isSmall = _ref.isSmall,
    groupUniqueID = _ref.groupUniqueID;
  return _react.default.createElement("div", {
    className: "agillicToggleButtonGroup",
    "data-testid": groupUniqueID
  }, _react.default.createElement("div", {
    className: "toggleAll"
  }, _react.default.createElement(_toggleButton.default, {
    isSmall: isSmall,
    isDisabled: toggleAllDisabled,
    tooltip: toggleAllTooltip,
    label: toggleAllLabel,
    isOn: !buttons.filter(function (_ref2) {
      var isDisabled = _ref2.isDisabled;
      return !isDisabled;
    }).map(function (_ref3) {
      var isOn = _ref3.isOn;
      return isOn;
    }).includes(false),
    onToggle: onToggleAll,
    uniqueID: groupUniqueID
  })), _react.default.createElement("div", {
    className: "toggleButtons"
  }, buttons.map(function (_ref4) {
    var isDisabled = _ref4.isDisabled,
      tooltip = _ref4.tooltip,
      label = _ref4.label,
      uniqueID = _ref4.uniqueID,
      isOn = _ref4.isOn,
      onToggle = _ref4.onToggle;
    return _react.default.createElement(_toggleButton.default, {
      key: uniqueID,
      isSmall: isSmall,
      isDisabled: isDisabled || toggleAllDisabled,
      tooltip: tooltip,
      label: label,
      isOn: isOn,
      onToggle: onToggle,
      uniqueID: uniqueID
    });
  })));
};
ToggleButtonGroup.propTypes = {
  buttons: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    uniqueID: _propTypes.string.isRequired,
    isOn: _propTypes.bool.isRequired,
    onToggle: _propTypes.func.isRequired,
    isDisabled: _propTypes.bool,
    tooltip: _propTypes.string,
    label: _propTypes.string
  })).isRequired,
  onToggleAll: _propTypes.func.isRequired,
  groupUniqueID: _propTypes.string.isRequired,
  isSmall: _propTypes.bool,
  areAllDisabled: _propTypes.bool,
  tooltip: _propTypes.string,
  label: _propTypes.string
};
var _default = ToggleButtonGroup;
exports.default = _default;